mpangoApp.filter('sum', function() {
	return function(data,key) {
		if (typeof(data)==='undefined'||typeof(key)==='undefined'){
			return 0;
		}  
		var sum = 0;
		for (var i = data.length - 1; i >= 0; i--) {
			if (typeof(data[i][key])==='string'||typeof(data[i][key])==='number'){ 
				sum += parseFloat(data[i][key]);
			}
		} 
		return sum;
	};
}).filter('dateFormat', function($filter)
	{
	return function(input)
	{
		if(input == null){ return ""; } 
		input = input.replace(/(.+) (.+)/, "$1T$2Z");
		var _date = $filter('date')(new Date(input), 'dd/MM/yyyy');

		return _date;

	};
}).filter('mUnique', function() {
   	return function(collection, keyname) {
      	var output = [], 
          	keys = [];
          	angular.forEach(collection, function(item) {
         	var key = item[keyname];
          	if(keys.indexOf(key) === -1) {
              	keys.push(key); 
              	output.push(item);
          	}
      	});
        return output;
   	};
});
